module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat4-e22e209f39058546ad7ad5fd63ab8a2c.jpg";